import React from 'react';

const TablePagination = ({ page, totalPages, onPrevious, onNext, className = '' }) => {
  if (totalPages <= 1) return null;

  return (
    <div className={['pagination', className].filter(Boolean).join(' ')}>
      <button type="button" disabled={page <= 1} onClick={onPrevious}>Previous</button>
      <span>Page {page} of {totalPages}</span>
      <button type="button" disabled={page >= totalPages} onClick={onNext}>Next</button>
    </div>
  );
};

export default TablePagination;
